import { useMemo } from 'react';
import { get } from 'lodash';
import { ChipProps } from '@mui/material';

import { DriverCompanyStateTypes } from '~globals/types/enums';

interface DriverCompanyStateInfoItem {
  description: string;
  color: NonNullable<ChipProps['color']>;
}

type DriverCompanyStateList = {
  [state in DriverCompanyStateTypes]: DriverCompanyStateInfoItem;
};

export const useDriverCompanyStateInfo = (
  stateId: DriverCompanyStateTypes,
): DriverCompanyStateInfoItem => {
  const stateList = useMemo<DriverCompanyStateList>(
    () => ({
      [DriverCompanyStateTypes.Pending]: {
        description: 'Pendiente',
        color: 'tertiary',
      },
      [DriverCompanyStateTypes.Approve]: {
        description: 'Activo',
        color: 'success',
      },
      [DriverCompanyStateTypes.Rejected]: {
        description: 'Rechazada',
        color: 'error',
      },
    }),
    [],
  );

  const currentInfo = useMemo<DriverCompanyStateInfoItem>(
    () => get(stateList, stateId),
    [stateId, stateList],
  );

  return currentInfo;
};
